module.exports = __webpack_public_path__ + "static/media/list_en.225dbeeb.png";